// extracted by mini-css-extract-plugin
export default {"inp":"DateInput_inp__bHTOn","dark":"DateInput_dark__IqvOI"};